<template>
  <div class="page-content">
    <base-screen>
      <el-form
        size="medium"
        :inline="true"
        :model="screenData"
        ref="screenForm"
        @keydown.native.enter="screenSubmit"
        @submit.native.prevent>
        <el-form-item label="标题名称：" prop="title">
          <el-input type="text" v-model="screenData.title" placeholder="标题" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input type="text" v-model="screenData.content" placeholder="内容" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="通知类型：" prop="type">
          <el-select v-model="screenData.type" placeholder="请选择通知类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="screenSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <el-button
          style="width: 100px"
          type="primary"
          @click="$emit('org-inform-view', 'org-inform-add', 'add')" v-pms="'add'">
          新建
        </el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="loading">
        <el-table-column
          prop="title"
          label="标题">
          <template slot-scope="{row}">
            <el-button type="text" class="link" @click="$emit('org-inform-view', 'org-inform-detail', row.informId)" v-pms="'look'">{{row.title}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="通知类型">
          <template slot-scope="{row}">
            <div v-if="row.type==1">员工通知</div>
            <div v-if="row.type==2">会员通知</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="通知内容"
        >
          <template slot-scope="{row}">
            <div v-html="row.content.length>=100?row.content.substring(0,100) + '...': row.content.substring(0,100)"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
         >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-button type="text" @click="$emit('org-inform-view', 'org-inform-add', row.informId)" v-pms="'edit'">编辑</el-button>
            <el-button type="text" @click="deleteForm(row.informId, row.title)" v-pms="'del'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>

    </div>
  </div>
</template>

<script>
import {orgInform} from '../../api'
import OrgInformAdd from './OrgInformAdd'

export default {
  name: 'OrgInform',
  components: {
    'org-inform-add': OrgInformAdd
  },
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      userId: this.$store.state.user.userId,
      options: [{label: '员工通知', value: '1'}, {label: '会员通知', value: '2'}],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      screenData: {
        title: '',
        content: '',
        type: '',
        orgCode: this.$store.state.user.orgCode
      },
      formData: { },
      rules: {
        title: [
          {required: true, message: '请输入标题名称', trigger: 'blur'},
          { max: 32, message: '长度不能超过32个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入通知类型', trigger: 'blue' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blue' }
        ]
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    changeEvent (value) {
      if (value === 'flush') this.getData()
    },
    deleteForm (id, name) {
      this.$confirm(`确定要删除【${name}】吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await orgInform.delOrgInfom({
          informId: id
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: `【${name}】删除成功`
          })
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg || `【${name}】删除失败`
          })
        }
      }, err => {
        console.log(err)
      })
    },
    async getData () {
      this.loading = true
      let {data, page} = await orgInform.getOrgInfomPage({
        page: this.page,
        param: this.screenData
      })
      this.loading = false
      this.tableData = data
      this.page = page
    },
    screenSubmit () {
      this.page['pageNum'] = 1
      this.getData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.page['pageNum'] = 1
      this.screenData.title = ''
      this.screenData.content = ''
      this.screenData.type = ''
      this.getData()
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    }
  }
}
</script>

<style scoped>
 .el-input {
   width: 300px;
 }
</style>
